<ng-container *ngIf="notifier">
  <div class="notifications">
    <ng-container *ngFor="let notification of notifier.notifications">
      <div
        class="notification is-danger mb-2"
        *ngIf="notification.type === FAIL"
        data-e2e="notifier is-fail"
        role="alert"
        aria-atomic="true"
      >
        <div class="icon">
          <i class="far fa-times-circle fa-lg"></i>
        </div>
        {{ notification.message }}
        <button
          class="close"
          (click)="destroy(notification)"
          data-e2e="notifier-close"
          type="button"
          title="Dismiss notification"
          i18n-title
        >
          <span class="icon">
            <i class="far fa-times fa-lg"></i>
          </span>
          <span class="is-sr-only" i18n>Dismiss notification</span>
        </button>
      </div>
      <div
        class="notification is-success mb-2"
        *ngIf="notification.type === SUCCESS"
        data-e2e="notifier is-success"
        role="status"
        aria-atomic="true"
      >
        <div class="icon">
          <i class="far fa-check-circle fa-lg"></i>
        </div>
        <div>
          <div>{{ notification.message }}</div>
          <div *ngIf="notification.copyText" class="pt-2">
            <span i18n>Order ID:</span>
            {{ notification.copyText }}
            <span
              class="pl-1 button-pointer"
              (click)="copyId(notification)"
            >
              <i
                class="far fa-lg"
                [ngClass]="notification.copied ? 'fa-check-circle' : 'fa-copy'"
              ></i>
            </span>
          </div>
        </div>
        <button
          class="close"
          (click)="destroy(notification)"
          data-e2e="notifier-close"
          type="button"
          title="Dismiss notification"
          i18n-title
        >
          <span class="icon">
            <i class="far fa-times fa-lg"></i>
          </span>
          <span class="is-sr-only" i18n>Dismiss notification</span>
        </button>
      </div>
      <div
        class="notification is-info mb-2"
        *ngIf="notification.type === INFO"
        data-e2e="notifier is-info"
        role="status"
        aria-atomic="true"
      >
        <div class="icon">
          <i class="far fa-info-circle fa-lg"></i>
        </div>
        {{ notification.message }}
        <button
          class="close"
          (click)="destroy(notification)"
          data-e2e="notifier-close"
          type="button"
          title="Dismiss notification"
          i18n-title
        >
          <span class="icon">
            <i class="far fa-times fa-lg"></i>
          </span>
          <span class="is-sr-only" i18n>Dismiss notification</span>
        </button>
      </div>
      <div
        class="notification is-warning mb-2"
        *ngIf="notification.type === WARN"
        data-e2e="notifier is-warn"
        role="alert"
        aria-atomic="true"
      >
        <div class="icon">
          <i class="far fa-exclamation-circle fa-lg"></i>
        </div>
        {{ notification.message }}
        <button
          class="close"
          (click)="destroy(notification)"
          data-e2e="notifier-close"
          type="button"
          title="Dismiss notification"
          i18n-title
        >
          <span class="icon">
            <i class="far fa-times fa-lg"></i>
          </span>
          <span class="is-sr-only" i18n>Dismiss notification</span>
        </button>
      </div>

      <div
        class="notification is-success mb-2"
        *ngIf="notification.type === REPORT"
        data-e2e="notifier is-success"
        role="status"
        aria-atomic="true"
      >
        <div class="icon">
          <i class="far fa-check-circle fa-lg"></i>
        </div>
        <div class="pt-0">
          Your report has been generated and can be viewed From the
          <a (click)="goto(notification.message)">Generated Reports</a> page

          <div class="field">
            <dt class="pt-2" i18n>
              Report ID :
              <p>
                {{ notification.message }}
                <span
                  class="pl-1 has-copy-icon button-pointer"
                  (click)="copy(notification.message)"
                ></span>
              </p>
            </dt>
          </div>
        </div>
        <button
          class="close"
          (click)="destroy(notification)"
          data-e2e="notifier-close"
          type="button"
          title="Dismiss notification"
          i18n-title
        >
          <span class="icon">
            <i class="far fa-times fa-lg"></i>
          </span>
          <span class="is-sr-only" i18n>Dismiss notification</span>
        </button>
      </div>

      <div
        class="notification is-toast mb-2"
        *ngIf="notification.type === TOAST"
        data-e2e="notifier is-toast"
        role="status"
        aria-atomic="true"
      >
        {{ notification.message }}
        <button
          class="close"
          (click)="destroy(notification)"
          data-e2e="notifier-close"
          type="button"
          title="Dismiss notification"
          i18n-title
        >
          <span class="icon">
            <i class="far fa-times fa-lg"></i>
          </span>
          <span class="is-sr-only" i18n>Dismiss notification</span>
        </button>
      </div>
    </ng-container>
  </div>
</ng-container>
